import { useState, useEffect } from 'react';
import { Button, ButtonSize, ButtonVariant, ButtonColor } from '@shipengine/giger';
import { getImageStyles } from './LocalPaymentStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';

const LocalPayment = _ref => {
  let {
    cdnUrl,
    type,
    ariaLabelText,
    buttonLoading = false,
    onPay
  } = _ref;
  const [loading, setLoading] = useState(buttonLoading);
  useEffect(() => {
    setLoading(!!buttonLoading);
  }, [buttonLoading]);
  return jsx(Button, {
    size: ButtonSize.LARGE,
    variant: ButtonVariant.OUTLINED,
    color: ButtonColor.SECONDARY,
    isFullWidth: true,
    onClick: onPay,
    isLoading: loading,
    "aria-label": ariaLabelText,
    children: jsx("img", {
      css: getImageStyles,
      src: `${cdnUrl}/apps/payment-method-logos/${type.toLocaleLowerCase()}.svg`,
      alt: type
    })
  });
};
LocalPayment.displayName = 'LocalPayment';

export { LocalPayment };
//# sourceMappingURL=LocalPayment.js.map
